var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit_",
    "data-name": "edit ",
    transform: "translate(-296 -1391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2649",
    "data-name": "Path 2649",
    d: "M26,26H0V0H26Z",
    transform: "translate(322 1391) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4563",
    "data-name": "Path 4563",
    d: "M13.485,3.942l1.276-1.277a1.418,1.418,0,0,1,2.006,2.006L8.735,12.7a3.4,3.4,0,0,1-1.435.855l-2.031.605.605-2.031A3.4,3.4,0,0,1,6.729,10.7l6.756-6.755Zm0,0,2,2m-1.135,5.2V14.73a1.7,1.7,0,0,1-1.7,1.7H4.7A1.7,1.7,0,0,1,3,14.73V6.788a1.7,1.7,0,0,1,1.7-1.7H8.295",
    transform: "translate(298.909 1394.659)",
    fill: "none",
    stroke: "#52555e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c987194a6b76e04f1980ce075bc28c44.svg";
export { ForwardRef as ReactComponent };